import { formatters, TextBox } from '@app/ui';
import { useUserContextSelector } from '@app/main/utils';
import { AppointmentRequestDeclineBlurb, AppointmentRequestDetailsWidgetProps } from '@mod/schedule';
import { useTranslation } from 'react-i18next';
import {
  PatientPortalAppointmentRequestVisitorRef,
  useGetPatientPortalAppointmentRequestQuery,
} from '@app/medical-record/api';

function hasPatientPortalAppointmentType(
  value: PatientPortalAppointmentRequestVisitorRef,
): value is PatientPortalAppointmentRequestVisitorRef & {
  appointmentType: NonNullable<PatientPortalAppointmentRequestVisitorRef['appointmentType']>;
} {
  return typeof value.appointmentType === 'object' && value.appointmentType !== null;
}

export function PatientPortalAppointmentRequestDetailsWidget(props: AppointmentRequestDetailsWidgetProps) {
  const { id } = props;
  const userId = useUserContextSelector((x) => x.id);
  const { t } = useTranslation(undefined, { keyPrefix: 'appointments' });
  const { data } = useGetPatientPortalAppointmentRequestQuery({ id });

  if (!data) {
    return null;
  }

  const currentUserVisitorRef = data.visitorRefs.find((visitorRef) => visitorRef.visitorId === userId) ?? null;
  const appointmentTypeName =
    currentUserVisitorRef && hasPatientPortalAppointmentType(currentUserVisitorRef)
      ? currentUserVisitorRef.appointmentType.name
      : null;

  return (
    <>
      <TextBox label={<span className="text-description">{t('reference')}</span>}>
        {appointmentTypeName ?? t('notApplicable')}
      </TextBox>

      {data.requestedPeriod && (
        <TextBox label={<span className="text-description">{t('requests.requestedPeriod')}</span>}>
          {`${formatters.datetime(data.requestedPeriod.start)} - ${formatters.timeOfTheDay(
            data.requestedPeriod.end,
          )}`}
        </TextBox>
      )}

      <TextBox label={<span className="text-description">{t('requests.note')}</span>}>
        {data.note ?? t('notApplicable')}
      </TextBox>

      <AppointmentRequestDeclineBlurb declinedNote={data.declinedNote} />
    </>
  );
}
